import KSLocationGroup from '../KSLocationGroup';
import { useState, useRef, useEffect } from 'react';
import { useUserLocationsQuery } from 'hooks/useUserLocationsQuery';
import KSClock from '../KSClock/KSClock';
import UserDropdownMenu from '../../../components/UserDropdown';
import './KSHeader.scss';
import { IconEmail, IconLink } from 'components/Icons';
import { Tooltip, Whisper } from 'rsuite';
import { generateEmailById } from '@hone-automation/common/lib/commonUtil';
import { FIVE_SECONDS, getHostEnvironment, showToast, TOAST_SUCCESS } from 'lib/utils';
import { useLocationsStore } from 'hooks/useLocationsStore';
import { shallow } from 'zustand/shallow';
import { useFlags } from 'launchdarkly-react-client-sdk';

function KSHeader() {
  const [copied, setCopied] = useState(false);
  const { queueShowEmailConfigured } = useFlags();
  const timerRef = useRef<number | null>(null);
  const { currentLocation } = useLocationsStore(
    state => ({ currentLocationId: state.currentLocationId, currentLocation: state.currentLocation }),
    shallow
  );

  const { data: userLocations } = useUserLocationsQuery();

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);

  // eslint-disable-next-line
  const emailTooltip = generateEmailById(currentLocation?.emailId!, getHostEnvironment());

  const handleCopyEmail = () => {
    if (emailTooltip) {
      navigator.clipboard.writeText(emailTooltip);
      showToast('Email copied to clipboard', TOAST_SUCCESS, FIVE_SECONDS);
    }
  };

  if (!userLocations) {
    return null;
  }

  return (
    <div className="ks-header">
      <KSLocationGroup locations={userLocations as HoneLocationUser[]} />
      <div className="ks-header-right">
        {queueShowEmailConfigured && (
          <Whisper
            placement="bottom"
            controlId="control-id-email-hover"
            delay={800}
            delayClose={100}
            trigger="hover"
            speaker={<Tooltip>{emailTooltip}</Tooltip>}
          >
            <div className="ks-header-right-link" onClick={handleCopyEmail} aria-label="copy link" role="button">
              <IconEmail />
            </div>
          </Whisper>
        )}
        <Whisper
          placement="bottom"
          controlId="control-id-hover"
          delay={800}
          delayClose={100}
          trigger="hover"
          speaker={<Tooltip>{copied ? 'Copied!' : 'Copy link'}</Tooltip>}
        >
          <div
            className="ks-header-right-link"
            onClick={() => {
              try {
                void navigator.clipboard.writeText(window.location.href);
                setCopied(true);
                if (timerRef.current) window.clearTimeout(timerRef.current);
                timerRef.current = window.setTimeout(() => setCopied(false), 1200);
              } catch (e) {
                // noop
              }
            }}
            aria-label="copy link"
            role="button"
          >
            <IconLink />
          </div>
        </Whisper>
        <KSClock />
        <UserDropdownMenu closedNavigationMenu={false} />
      </div>
    </div>
  );
}

export default KSHeader;
